@if (isLoading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<div class="p-col-12 p-lg-12 mb30">
  <div class="ui-g">
    <div class="ui-g-12 ui-md-12 text-center">
      <p-button
        type="button"
        pButton
        pTooltip="Click here to Lookup Tenant"
        tooltipPosition="bottom"
        (click)="customerSearch()">
        Click here to Lookup Tenant
      </p-button>
    </div>
  </div>

  @if (showResult) {
    <div>
      <div class="ui-g card">
        <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
          <div class="sbhd">Tenant Information</div>
          <table>
            <tr>
              <th class="colsmall">Tenant Name</th>
              <th class="colmedium">TenantId</th>
              <th class="colxsmall">TPId</th>
              <th class="colsmall">Initial Domain</th>
              <th class="colmedium">Default Domain</th>
              <th class="colxsmall"></th>
            </tr>
            <ng-template
              ngFor
              let-selectedCustomer
              [ngForOf]="selectedCustomer"
              let-i="index">
              <tr>
                <td>{{ selectedCustomer.tenantName }}</td>
                <td>{{ selectedCustomer.tenantId }}</td>
                <td>{{ selectedCustomer.tpId }}</td>
                <td>{{ selectedCustomer.initialDomain }}</td>
                <td>{{ selectedCustomer.defaultDomain }}</td>
                <td>
                  <a
                    (click)="tenantInfo()"
                    tabindex="0"
                    (keydown.enter)="tenantInfo()"
                    >view more
                    <i class="fa fa-external-link" aria-hidden="true"></i
                  ></a>
                </td>
              </tr>
            </ng-template>
          </table>
        </div>
      </div>

      <div class="ui-g card">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="engactivity">
            <div class="sbhd">Engagements Status</div>
            <table>
              <tr>
                <ng-template ngFor let-engStatus [ngForOf]="engagementStatus">
                  <td>
                    {{ engStatus.status }}<br /><span>{{
                      engStatus.noOfEngagements
                    }}</span>
                  </td>
                </ng-template>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="ui-g card">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <p-tabs scrollable value="0">
            <p-tablist>
              <p-tab value="0">Eligible Engagements</p-tab>
              <p-tab value="1">Ineligible Engagements</p-tab>
              <p-tab value="2">All Nominations</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="0">
                <p-table
                  #eg
                  [columns]="cols"
                  [scrollable]="true"
                  [style]="{ width: '100%' }"
                  [value]="eligibleEngagements"
                  selectionMode="single"
                  [loadingIcon]="loadingIcon"
                  [showLoader]="true"
                  [(selection)]="selectedItem"
                  [paginator]="true"
                  [rows]="5"
                  paginatorPosition="top">
                  <ng-template #header>
                    <tr>
                      <th [pSortableColumn]="'engagementName'" class="colsmall">
                        Engagement Name
                        <p-sortIcon [field]="'engagementName'"></p-sortIcon>
                      </th>
                      <th
                        [pSortableColumn]="'engagementSubType'"
                        class="colmedium">
                        Engagement SubType
                        <p-sortIcon [field]="'engagementSubType'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'eligibleFund'" class="colsmall">
                        Eligible Fund
                        <p-sortIcon [field]="'eligibleFund'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'isC3Engagement'" class="colsmall">
                        Is SMC Engagement
                        <p-sortIcon [field]="'isC3Engagement'"></p-sortIcon>
                      </th>
                    </tr>
                    <tr>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            eg.filter(
                              $any($event.target).value,
                              'engagementName',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            eg.filter(
                              $any($event.target).value,
                              'engagementSubType',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            eg.filter(
                              $any($event.target).value,
                              'eligibleFund',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            eg.filter(
                              $any($event.target).value,
                              'isC3Engagement',
                              'contains'
                            )
                          " />
                      </th>
                    </tr>
                    <tr></tr
                  ></ng-template>
                  <ng-template
                    #body
                    let-eligibleEngagements
                    let-columns="columns">
                    <tr>
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ eligibleEngagements.engagementName }}"
                          >{{ eligibleEngagements.engagementName }}</span
                        >
                      </td>
                      <td class="colmedium">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ eligibleEngagements.engagementSubType }}"
                          >{{ eligibleEngagements.engagementSubType }}</span
                        >
                      </td>
                      <td class="colsmall">
                        ${{ eligibleEngagements.eligibleFund }}
                      </td>
                      @if (eligibleEngagements.isC3Engagement === 1) {
                        <td class="colsmall">True</td>
                      }
                      @if (eligibleEngagements.isC3Engagement === 0) {
                        <td class="colsmall">False</td>
                      }
                    </tr>
                  </ng-template>
                </p-table>
              </p-tabpanel>
              <p-tabpanel value="1">
                <p-table
                  #ieg
                  [columns]="cols"
                  [scrollable]="true"
                  [style]="{ width: '100%' }"
                  [value]="inEligibleEngagements"
                  selectionMode="single"
                  [loadingIcon]="loadingIcon"
                  [showLoader]="true"
                  [(selection)]="selectedItem"
                  [paginator]="true"
                  [rows]="5"
                  paginatorPosition="top">
                  <ng-template #header>
                    <tr>
                      <th [pSortableColumn]="'engagementName'" class="colsmall">
                        Engagement Name
                        <p-sortIcon [field]="'engagementName'"></p-sortIcon>
                      </th>
                      <th
                        [pSortableColumn]="'engagementSubType'"
                        class="colmedium">
                        Engagement SubType
                        <p-sortIcon [field]="'engagementSubType'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'eligibleFund'" class="colsmall">
                        Eligible Fund
                        <p-sortIcon [field]="'eligibleFund'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'isC3Engagement'" class="colsmall">
                        Is SMC Engagement
                        <p-sortIcon [field]="'isC3Engagement'"></p-sortIcon>
                      </th>
                      <th
                        [pSortableColumn]="'reasonForIneligibility'"
                        class="colmedium">
                        Reason For Ineligibility
                        <p-sortIcon
                          [field]="'reasonForIneligibility'"></p-sortIcon>
                      </th>
                    </tr>
                    <tr>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            ieg.filter(
                              $any($event.target).value,
                              'engagementName',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            ieg.filter(
                              $any($event.target).value,
                              'engagementSubType',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            ieg.filter(
                              $any($event.target).value,
                              'eligibleFund',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            ieg.filter(
                              $any($event.target).value,
                              'isC3Engagement',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            ieg.filter(
                              $any($event.target).value,
                              'reasonForIneligibility',
                              'contains'
                            )
                          " />
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template
                    #body
                    let-inEligibleEngagements
                    let-columns="columns">
                    <tr>
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ inEligibleEngagements.engagementName }}"
                          >{{ inEligibleEngagements.engagementName }}</span
                        >
                      </td>
                      <td class="colmedium">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{
                            inEligibleEngagements.engagementSubType
                          }}"
                          >{{ inEligibleEngagements.engagementSubType }}</span
                        >
                      </td>
                      <td class="colsmall">
                        ${{ inEligibleEngagements.eligibleFund }}
                      </td>
                      @if (inEligibleEngagements.isC3Engagement === 1) {
                        <td class="colsmall">True</td>
                      }
                      @if (inEligibleEngagements.isC3Engagement === 0) {
                        <td class="colsmall">False</td>
                      }
                      <td class="colmedium">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{
                            inEligibleEngagements.reasonForIneligibility
                          }}"
                          >{{
                            inEligibleEngagements.reasonForIneligibility
                          }}</span
                        >
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-tabpanel>
              <p-tabpanel value="2">
                <p-table
                  #al
                  [columns]="cols"
                  [scrollable]="true"
                  [style]="{ width: '100%' }"
                  [value]="allNominations"
                  selectionMode="single"
                  [loadingIcon]="loadingIcon"
                  [showLoader]="true"
                  [(selection)]="selectedItem"
                  [paginator]="true"
                  [rows]="5"
                  paginatorPosition="top">
                  <ng-template #header>
                    <tr>
                      <th [pSortableColumn]="'engagementID'" class="colmedium">
                        Engagement ID
                        <p-sortIcon [field]="'engagementID'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'engagementName'" class="collarge">
                        Engagement Name
                        <p-sortIcon [field]="'engagementName'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'engagementType'" class="collarge">
                        Engagement Type
                        <p-sortIcon [field]="'engagementType'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'customerName'" class="collarge">
                        Customer Name
                        <p-sortIcon [field]="'customerName'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'status'" class="colsmall">
                        Status <p-sortIcon [field]="'status'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'fundingAmount'" class="colmedium">
                        Funding Amount
                        <p-sortIcon [field]="'fundingAmount'"></p-sortIcon>
                      </th>
                      <th
                        [pSortableColumn]="'expirationDate'"
                        class="colmedium">
                        Expiration Date
                        <p-sortIcon [field]="'expirationDate'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'nominatedBy'" class="colmedium">
                        Nominated By
                        <p-sortIcon [field]="'nominatedBy'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'poeStatus'" class="colsmall">
                        POE Status
                        <p-sortIcon [field]="'poeStatus'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'workshopDate'" class="colmedium">
                        Workshop Date
                        <p-sortIcon [field]="'workshopDate'"></p-sortIcon>
                      </th>
                    </tr>
                    <tr>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'engagementID',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable collarge">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'engagementName',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable collarge">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'engagementType',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable collarge">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'customerName',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'status',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'fundingAmount',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'expirationDate',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'nominatedBy',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'poeStatus',
                              'contains'
                            )
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            al.filter(
                              $any($event.target).value,
                              'workshopDate',
                              'contains'
                            )
                          " />
                      </th>
                    </tr>
                    <tr></tr
                  ></ng-template>
                  <ng-template #body let-allNominations let-columns="columns">
                    <tr>
                      <td class="colmedium">
                        <a
                          (click)="
                            editRequestDetails(
                              $event,
                              allNominations.engagementID
                            )
                          "
                          (keydown.enter)="
                            editRequestDetails(
                              $event,
                              allNominations.engagementID
                            )
                          "
                          tabindex="0"
                          class="editlink"
                          tooltipPosition="top"
                          pTooltip="{{ allNominations.engagementID }}"
                          >{{ allNominations.engagementID }}</a
                        >
                      </td>
                      <td class="collarge">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ allNominations.engagementName }}"
                          >{{ allNominations.engagementName }}</span
                        >
                      </td>
                      <td class="collarge">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ allNominations.engagementType }}"
                          >{{ allNominations.engagementType }}</span
                        >
                      </td>
                      <td class="collarge">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ allNominations.customerName }}"
                          >{{ allNominations.customerName }}</span
                        >
                      </td>
                      <td class="colsmall">{{ allNominations.status }}</td>
                      <td class="colmedium">
                        ${{ allNominations.fundingAmount }}
                      </td>
                      <td class="colmedium">
                        {{ allNominations.expirationDate }}
                      </td>
                      <td class="colmedium">
                        {{ allNominations.nominatedBy }}
                      </td>
                      <td class="colsmall">{{ allNominations.poeStatus }}</td>
                      <td class="colmedium">
                        {{ allNominations.workshopDate }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
      </div>

      <div class="ui-g card">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="sbhd">Partners</div>
          <p-table
            #pa
            [columns]="cols"
            [scrollable]="true"
            [style]="{ width: '100%' }"
            [value]="selectUsageByPartners"
            selectionMode="single"
            [loadingIcon]="loadingIcon"
            [showLoader]="true"
            [(selection)]="selectedItem"
            [paginator]="true"
            [rows]="5"
            paginatorPosition="top">
            <ng-template #header>
              <tr>
                <th [pSortableColumn]="'partnerId'" class="colxsmall">
                  Partner ID <p-sortIcon [field]="'partnerId'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'partnerName'" class="collarge">
                  Partner Name <p-sortIcon [field]="'partnerName'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'engagementName'" class="colsmall">
                  Engagement Name
                  <p-sortIcon [field]="'engagementName'"></p-sortIcon>
                </th>
                <th
                  [pSortableColumn]="'requestedEngagementType'"
                  class="colmedium">
                  Requested Engagement Type
                  <p-sortIcon [field]="'requestedEngagementType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'status'" class="colxsmall">
                  Status <p-sortIcon [field]="'status'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'noOfEngagements'" class="colsmall">
                  No of Engagements
                  <p-sortIcon [field]="'noOfEngagements'"></p-sortIcon>
                </th>
              </tr>
              <tr>
                <th class="dashtable colxsmall">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter(
                        $any($event.target).value,
                        'partnerId',
                        'contains'
                      )
                    " />
                </th>
                <th class="dashtable collarge">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter(
                        $any($event.target).value,
                        'partnerName',
                        'contains'
                      )
                    " />
                </th>
                <th class="dashtable colsmall">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter(
                        $any($event.target).value,
                        'engagementName',
                        'contains'
                      )
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter(
                        $any($event.target).value,
                        'requestedEngagementType',
                        'contains'
                      )
                    " />
                </th>
                <th class="dashtable colxsmall">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter($any($event.target).value, 'status', 'contains')
                    " />
                </th>
                <th class="dashtable colsmall">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      pa.filter(
                        $any($event.target).value,
                        'noOfEngagements',
                        'contains'
                      )
                    " />
                </th>
              </tr>
              <tr></tr
            ></ng-template>
            <ng-template #body let-partnerUsageDetails let-columns="columns">
              <tr>
                <td class="colxsmall">
                  <a
                    (click)="redirectToPartner(partnerUsageDetails.partnerId)"
                    class="editlink"
                    (keydown.enter)="
                      redirectToPartner(partnerUsageDetails.partnerId)
                    "
                    tabindex="0"
                    >{{ partnerUsageDetails.partnerId }}</a
                  >
                </td>
                <td class="collarge">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ partnerUsageDetails.partnerName }}"
                    >{{ partnerUsageDetails.partnerName }}</span
                  >
                </td>
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ partnerUsageDetails.engagementName }}"
                    >{{ partnerUsageDetails.engagementName }}</span
                  >
                </td>
                <td class="colmedium">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ partnerUsageDetails.requestedEngagementType }}"
                    >{{ partnerUsageDetails.requestedEngagementType }}</span
                  >
                </td>
                <td class="colxsmall">{{ partnerUsageDetails.status }}</td>
                <td class="colsmall">
                  {{ partnerUsageDetails.noOfEngagements }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>

<p-dialog
  [(visible)]="loadCustomerSearch"
  [contentStyle]="{ 'max-height': '550px', 'overflow-y': 'auto' }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="true"
  [style]="{ width: '780px' }">
  <ng-template #header>
    <div class="ui-g-11 upload-header">
      Search Tenant Id/Tenant Name/Tp Id/Tp Name
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="cancelSearchNav()"
      (keyup.enter)="cancelSearchNav()"
      (keyup.space)="cancelSearchNav()"
      tabindex="0">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>
  @if (loadCustomerSearch) {
    <app-search-customer
      (isLoading)="onLoading($event)"
      (selCustomer)="selectedTiD($event)"
      (closeSearchnav)="
        loadCustomerSearch = $any($event)
      "></app-search-customer>
  }
</p-dialog>

<p-dialog
  resizable="false"
  [closable]="false"
  [draggable]="false"
  [(visible)]="loadTenantInfo"
  modal="modal"
  showEffect="fade"
  [style]="{ width: '700px' }">
  <ng-template #header>
    <div class="ui-g-11 upload-header">Tenant Information</div>
    <div
      class="closesidebar"
      tabindex="0"
      role="button"
      (click)="cancelTenantInfo()"
      (keyup.enter)="cancelTenantInfo()"
      (keyup.space)="cancelTenantInfo()"
      aria-label="Close Tenant Info">
      X
    </div>
  </ng-template>
  <div class="dialogtable tcontent">
    <ng-template
      ngFor
      let-selectedCustomer
      [ngForOf]="selectedCustomer"
      let-i="index">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th>Tenant Id</th>
          <td>{{ selectedCustomer.tenantId }}</td>
        </tr>
        <tr>
          <th>Tenant Name</th>
          <td>{{ selectedCustomer.tenantName }}</td>
        </tr>
        <tr>
          <th>Current Default Domain</th>
          <td>{{ selectedCustomer.currentDefaultDomain }}</td>
        </tr>
        <tr>
          <th>Initial Domain</th>
          <td>{{ selectedCustomer.initialDomain }}</td>
        </tr>
        <tr>
          <th>Default Domain</th>
          <td>{{ selectedCustomer.defaultDomain }}</td>
        </tr>
        <tr>
          <th>Tp Id</th>
          <td>{{ selectedCustomer.tpId }}</td>
        </tr>
        <tr>
          <th>Tp Name</th>
          <td>{{ selectedCustomer.tpName }}</td>
        </tr>
        <tr>
          <th>Subsidiary</th>
          <td>{{ selectedCustomer.subsidiary }}</td>
        </tr>
        <tr>
          <th>SubRegion</th>
          <td>{{ selectedCustomer.subRegion }}</td>
        </tr>
        <tr>
          <th>Region</th>
          <td>{{ selectedCustomer.region }}</td>
        </tr>
        <tr>
          <th>Area</th>
          <td>{{ selectedCustomer.area }}</td>
        </tr>
        <tr>
          <th>SegmentGroup</th>
          <td>{{ selectedCustomer.segmentGroup }}</td>
        </tr>
        <tr>
          <th>Segment</th>
          <td>{{ selectedCustomer.segment }}</td>
        </tr>
        <tr>
          <th>Subsegment</th>
          <td>{{ selectedCustomer.subsegment }}</td>
        </tr>
        <tr>
          <th>Exo PAU</th>
          <td>{{ selectedCustomer.exoQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>Exo MAU</th>
          <td>{{ selectedCustomer.exoActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>Exo MAU/PAU Percent</th>
          <td>{{ selectedCustomer.exoaeqePercent }}</td>
        </tr>
        <tr>
          <th>Teams PAU</th>
          <td>{{ selectedCustomer.teamsQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>Teams MAU</th>
          <td>{{ selectedCustomer.teamsActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>Teams MAU/PAU Percent</th>
          <td>{{ selectedCustomer.teamsAEQEPercent }}</td>
        </tr>
        <tr>
          <th>ProPlus PAU</th>
          <td>{{ selectedCustomer.proPlusQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>ProPlus MAU</th>
          <td>{{ selectedCustomer.proPlusMAU }}</td>
        </tr>
        <tr>
          <th>ProPlus MAU/PAU Percent</th>
          <td>{{ selectedCustomer.proPlusMAUQEPercent }}</td>
        </tr>
        <tr>
          <th>Win10 Deployments</th>
          <td>{{ selectedCustomer.win10Deployments }}</td>
        </tr>
        <tr>
          <th>Adjusted PCIB</th>
          <td>{{ selectedCustomer.adjustedPCIB }}</td>
        </tr>
        <tr>
          <th>Win10 MAD</th>
          <td>{{ selectedCustomer.win10MAD }}</td>
        </tr>
        <tr>
          <th>Win10MAD Adjusted PCIBPercent</th>
          <td>{{ selectedCustomer.win10MADAdjustedPCIBPercent }}</td>
        </tr>
        <tr>
          <th>SfB PAU</th>
          <td>{{ selectedCustomer.sfBQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>SfB MAU</th>
          <td>{{ selectedCustomer.sfBActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>SfB MAU/PAU Percent</th>
          <td>{{ selectedCustomer.sfBAEQEPercent }}</td>
        </tr>
        <tr>
          <th>Spo PAU</th>
          <td>{{ selectedCustomer.spoQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>Spo MAU</th>
          <td>{{ selectedCustomer.spoActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>Spo MAU/PAU Percent</th>
          <td>{{ selectedCustomer.spoaeqePercent }}</td>
        </tr>
        <tr>
          <th>Snapshot Date</th>
          <td>{{ selectedCustomer.snapshotDate }}</td>
        </tr>
        <tr>
          <th>AADP PAU</th>
          <td>{{ selectedCustomer.aadpQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>AADP MAU</th>
          <td>{{ selectedCustomer.aadpActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>AADP MAU/PAU Percent</th>
          <td>{{ selectedCustomer.aadpaeqePercent }}</td>
        </tr>
        <tr>
          <th>Teams Meetings PAU</th>
          <td>{{ selectedCustomer.teamsMeetingsQualifiedEntitlements }}</td>
        </tr>
        <tr>
          <th>Teams Meetings MAU</th>
          <td>{{ selectedCustomer.teamsMeetingsActiveEntitlements }}</td>
        </tr>
        <tr>
          <th>Teams Meetings MAU/PAU Percent</th>
          <td>{{ selectedCustomer.teamsMeetingsMAUQEPercent }}</td>
        </tr>
      </table>
    </ng-template>
  </div>
</p-dialog>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [(visible)]="editNav"
    modal="modal"
    showEffect="fade"
    (onHide)="onCloseEditModal()"
    [maximizable]="true"
    [style]="{ width: '90vw' }"
    [draggable]="false"
    [resizable]="false">
    @if (loadEditComponent) {
      <app-edit
        [engagementEditInput]="engagementEditInput"
        #editNavChild
        (showFullscreen)="onShowFullScreenChanged($any($event))"
        (closeEditSidebar)="editNav = $any($event)"></app-edit>
    }
  </p-dialog>
}
